<div class="main">
  <div class="col-12 d-flex flex-column page-content border border-radius w-100">
    <nz-table [nzData]="dataSet" [nzSize]="'small'" [nzFrontPagination]="false" [nzShowPagination]="false"
      (nzQueryParams)="sort($event)" [nzNoResult]="semDadosTemplate">
      <thead>
        <tr>
          <th nzColumnKey="dataCadastro" nzShowSort [nzSortFn]="true">Data Cadastro</th>
          <th nzColumnKey="historico" nzShowSort [nzSortFn]="true">Histórico</th>
          <th class="text-center">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of dataSet">
          <td>{{ item?.dataCadastro | date: 'dd/MM/yyyy' }}</td>
          <td>{{ item?.historico }}</td>
          <td></td>
        </tr>
      </tbody>
    </nz-table>
    <ng-template #footerTemplate>
      <section class="d-flex justify-content-end w-100">
        <app-pagination [itemPorPagina]="10"></app-pagination>
      </section>
    </ng-template>
    <ng-template #semDadosTemplate>
      <div class="d-flex align-items-center justify-content-center" *ngIf="!dataSet?.length">
        <nz-empty [nzNotFoundContent]="'Nenhum registro encontrado'"></nz-empty>
      </div>
    </ng-template>
  </div>
</div>
